module.exports = __webpack_public_path__ + "img/gd.64e80af4.svg";